var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHourglasswhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/timer"
  }, /*#__PURE__*/React.createElement("g", {
    id: "timer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.6999 1.66699H7.29995C4.16662 1.66699 3.92495 4.48366 5.61662 6.01699L14.3833 13.9837C16.0749 15.517 15.8333 18.3337 12.6999 18.3337H7.29995C4.16662 18.3337 3.92495 15.517 5.61662 13.9837L14.3833 6.01699C16.0749 4.48366 15.8333 1.66699 12.6999 1.66699Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHourglasswhite);
export default __webpack_public_path__ + "static/media/hourglasswhite.b883764b.svg";
export { ForwardRef as ReactComponent };